/** Keep previews working before the optional CMS field migration is deployed. */
export async function queryPageWithSchemaOverride<T>(
  query: (document: string) => Promise<T>,
  document: string,
): Promise<T> {
  try {
    return await query(document)
  } catch (error) {
    // Retry only this explicit schema-version mismatch. Network, permission and
    // other GraphQL errors must remain visible rather than hiding missing pages.
    if (!(error instanceof Error) || !/Cannot query field ["']schemaPageType["'] on type ["']page_Entry["']/.test(error.message)) throw error
    return query(document.replace(/^\s*schemaPageType\s*$/m, ''))
  }
}
